<template>

  <div class="Image" :url="getUrl">
    <viewer :images="urlArr" v-if="showImage">
      <img class="avatar-url" v-for="src in urlArr" :src="src" :key="src" alt="" />
    </viewer>
  </div>
</template>

<script>

export default {
  props: {
    url: {
      type: String
    },
    show: true
  },
  name: "mImage",
  data() {
    return {
      urlArr: [],
      showImage: false
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$previewRefresh();
    // });
  },
  methods: {
    // errorImg(index) {
    //   this.urlArr.splice(index, 1);
    //   this.$previewRefresh();
    // }
  },
  computed: {
    getUrl() {
      const { url } = this;
      this.urlArr = url?.split(";") || [];
      this.showImage = !!this.urlArr.length;
      return this.url;
    }
  }
};
</script>

<style scoped lang="less">
.Image {
  width: 100%;
  height: 40px;
  display: flex;
  overflow: hidden;
  max-width: 195px;
  justify-content: center;

  img {
    width: 60px;
    height: 40px;
    margin-right: 5px;
  }

  .item {
    margin-right: 5px;
  }
}
</style>
